module.exports = __webpack_public_path__ + "static/media/nutritionist.c29a5043.png";